import { render, staticRenderFns } from "./contentDialog.vue?vue&type=template&id=10745932&"
import script from "./contentDialog.vue?vue&type=script&lang=js&"
export * from "./contentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports